(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-wishlist-button"] && !Shopify.designMode) return;
  try {
    (function () {
    function setState(button, added) {
      button.classList.toggle('is-added', added);
      button.setAttribute('aria-pressed', String(added));
      var label = added ? 'Remove from Wishlist' : 'Add to Wishlist';
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    }

    function productOf(button) {
      return {
        epi: Number(button.dataset.variantId),
        empi: Number(button.dataset.productId),
        du: button.dataset.productUrl,
      };
    }

    function refresh(swat, buttons) {
      swat.fetch(function (items) {
        var saved = (items || []).map(function (item) { return Number(item.empi); });
        buttons.forEach(function (button) {
          setState(button, saved.indexOf(Number(button.dataset.productId)) > -1);
        });
      });
    }

    function init(swat) {
      var buttons = Array.prototype.slice.call(document.querySelectorAll('.product-wishlist-button:not([data-wishlist-ready])'));
      if (!buttons.length) return;

      buttons.forEach(function (button) {
        button.setAttribute('data-wishlist-ready', '');
        button.hidden = false;
        button.addEventListener('click', function () {
          if (button.getAttribute('aria-busy') === 'true') return;
          var added = button.classList.contains('is-added');
          button.setAttribute('aria-busy', 'true');
          var done = function () {
            button.removeAttribute('aria-busy');
            refresh(swat, [button]);
          };
          var product = productOf(button);
          if (added) {
            swat.api.removeFromWishList(product, done, done);
          } else {
            swat.api.addToWishList(product, done, done);
          }
        });
      });

      refresh(swat, buttons);
    }

    function start() {
      if (window._swat && window._swat.api) {
        init(window._swat);
      } else {
        window.SwymCallbacks = window.SwymCallbacks || [];
        window.SwymCallbacks.push(init);
      }
    }

    start();
    // Horizon re-renders the product section on variant change; pick up the new button.
    document.addEventListener('variant:update', function () { setTimeout(start, 0); });
  })();
  } catch(e) { console.error(e); }
})();

})();
